<template>
  <div class="form-group col-12 px-0 my-auto">
    <div class="position-relative">
      <div class="d-flex flex-row">
        <label class="text-gray-600"> {{ label }} </label>
      </div>
      <div class="row">
        <div
          v-for="(item, index) in list"
          :key="item.name + index"
          class="col-12 col-sm-6 mb-3"
        >
          <button
            type="button"
            :class="`btn btn-block mb-sm-0
            ${isSelected(item) ? 'text-primary': 'text-gray-600 border-gray-400'}
            ${index === list.length - 1 ? '': 'mb-3'}`"
            style="background: #edf4fd; box-shadow: 0 0 0"
            :style="isSelected(item) ? '': 'background: white'"
            @click="!isSelected(item) ? setCustomModel(item) : null"
          >
            {{ item.name }}
            <font-awesome-icon
              v-if="item.icon"
              :icon="item.icon"
              class="position-absolute"
              style="width:16px; height: 16px; right: 15%; top: 50%; transform: translate(0, -50%);"
            />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { transform } from '@/mixins';

export default {
  name: 'InputRadio',
  mixins: [transform],
  props: {
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    path: {
      type: String,
      required: true,
      default: 'name',
    },
    name: {
      type: String,
      required: true,
      default: 'name',
    },
    actionModule: {
      type: String,
      required: false,
      default: 'company',
    },
    actionName: {
      type: String,
      required: false,
      default: 'setValueWithPath',
    },
    callbackAction: {
      type: String,
      required: false,
      default: '',
    },
    setterFunction: {
      type: Function,
      default: (value) => value,
    },
    customDefault: {
      type: [String, Boolean, null],
      default: null,
    },
  },
  data() {
    return {
      customValue: '',
    };
  },
  computed: {
    actionStore() {
      return `${this.actionModule}/${this.actionName}`;
    },
  },
  watch: {
    customDefault: {
      handler(value) {
        this.customValue = value;
      },
    },
  },
  mounted() {
    this.customValue = this.customDefault;
  },
  methods: {
    isSelected(item) {
      return item.value === this.customValue;
    },
    async setCustomModel(item) {
      await this.$store.dispatch(this.actionStore, {
        name: this.name,
        path: this.path,
        value: this.setterFunction(item.value),
      });
      this.customValue = item.value;
      this.$emit('validation', true);
      if (this.callbackAction !== '') {
        await this.$store.dispatch(this.callbackAction, item.value);
      }
    },
  },
};
</script>
